(function () {
    'use strict';

    angular
        .module('app')
        .controller('releasecheckout', releasecheckout);

    releasecheckout.$inject = ['$location', '$scope', '$rootScope', 'gridDataService', '$q', 'selectionCommandService', '$timeout', '$mdDialog', 'records', 'command', 'commandService', 'loginService', 'editEmailsService', 'zcs'];

    function releasecheckout($location, scope, $rootScope, gridDataService, $q, selectionCommandService, $timeout, $mdDialog, records, command, commandService, loginService, editEmailsService, zcs) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'releasecheckout';

        scope.releaseCheckOutDialogShown = false;

        scope.ACN_RELEASE_OWNERSHIP = 107
        scope.xyz = {};

        scope.$on('releaseCheckOutButtonClicked', function (event, arg) {
            scope.onReleaseCheckOutButtonClicked(arg.slx);
        });

        scope.processingLabel = loginService.resourceStrings["PROCESSING"];

        // On click of the Assign button.
        scope.onReleaseCheckOutButtonClicked = function (slx) {
            // scope
            scope.slx = slx;
            scope.xyz = {};

            scope.gridOptions.columnDefs = [{ name: 'Name', field: 'name', width: '33%', minWidth: '100' },
                { name: 'Library', field: 'library', width: '33%', minWidth: '100' }];

            // dialog config
            scope.heading = loginService.resourceStrings["RELEASE_CHECK_OUT"]; // "Assign";
            if (scope.slx.list.length <= 1) {
                scope.filesLabel = loginService.resourceStrings["RELEASE_CHECK_OUT_FILE"];
            }
            else {
                scope.filesLabel = loginService.resourceStrings["RELEASE_CHECK_OUT_FILES"]; // "Files to Assign:";
                scope.filesLabel = scope.filesLabel.replace('{0}', '' + scope.slx.list.length);
            }
            scope.OK = loginService.resourceStrings["OK"]; // "OK";
            scope.Cancel = loginService.resourceStrings["CANCEL"]; // "Cancel";
            // dialog config columns
            scope.doColumns();

            // For each selection item, add a row to the grid.
            scope.gridOptions.data = [];
            var index = 0;
            angular.forEach(scope.slx.list, function (item) {
                // Add item.
                scope.gridOptions.data.push({
                    index: index,
                    selectionItem: item,
                    isSelected: true,
                    name: item.filename, library: item.detailedInfo.libName
                });
                index++;
            });

            // Enables.
            //scope.selectItem();
            // Do modal.
            scope.releaseCheckoutDialogShown = true;
            $timeout(function () {
                refreshGrid();
                scope.gridApi.selection.selectAllRows();
                $timeout(function () {
                    refreshGrid();
                }, 2000);
            }, 500);
        };


        scope.doColumns = function () {
            // dialog config columns
            var colName = loginService.resourceStrings["SCHEMA_S_LONGNAME"];
            var colLibrary = loginService.resourceStrings["SCHEMA_S_LIBNAME"];
            scope.gridOptions.columnDefs[0].name = colName;
            scope.gridOptions.columnDefs[1].name = colLibrary;
        }

        scope.onDisableTest = function () {
            scope.xyz.processing = !scope.xyz.processing;
        }

        scope.onReleaseCheckOutDialogOK = function () {
            scope.xyz.processing = true;
            // Execute.
            selectionCommandService.ReleaseCheckOut(scope.slx).then(function (response) {
                var selectionCommandResults = response.data;
                var slx = selectionCommandResults.slx;

                // No file ops. Release leaves a DUP.
                //// Final file ops.
                //if (selectionCommandResults.fileOperationPacket) {
                //    // Call ACS to do the file operations for the deletes.
                //    zcs.ProcessFileOperationPacket(selectionCommandResults.fileOperationPacket).then(function (response) {
                //    }, function () {
                //    });
                //}

                // Handle errors.
                var atLeastOneError = false;
                angular.forEach(slx.list, function (item) {
                    if (atLeastOneError == false) {
                        if (item.ec != 0) {
                            atLeastOneError = true;
                            if (atLeastOneError) {
                                commandService.launchErrors({ slx: slx });
                            }
                        }
                    }
                });
                // Close dialog and refresh grid.
                $mdDialog.hide();
                scope.xyz.processing = false;

                // Paul.Ligowski ABC OUT from ABC IN. Creates ABC IN which is the update, and XYZ DUP which isn't anywhere.
                // So, don't update. Instead, reload.
                gridDataService.updateGridRecords(slx.list);
                //gridDataService.reloadGrid();

                editEmailsService.showEditEmailsDialog(selectionCommandResults.emails);
            }, function (response) {
                selectionCommandService.ShowEx(response); scope.xyz.processing = false;
            });
        };

        scope.onReleaseCheckOutDialogCancel = function () {
            // Close dialog.
            $mdDialog.hide();
        };

        scope.releaseCheckOutDialogClosed = function () {

        }

        var refreshGrid = function () {
            scope.gridApi.grid.handleWindowResize();
            scope.gridApi.grid.refreshCanvas();
            scope.gridApi.grid.refresh();
        }

        var onRegisterApi = function (gridApi) {
            scope.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged(scope, scope.selectItem);
            gridApi.selection.on.rowSelectionChangedBatch(scope, scope.selectItem);
            scope.onReleaseCheckOutButtonClicked(records);
        }

        scope.gridApi = {};

        scope.gridOptions = {
            data: [],
            enableSelectionBatchEvent: true,
            multiSelect: true,
            modifierKeysToMultiSelect: true,
            enableFullRowSelection: true,
            enableRowHeaderSelection: false,
            useExternalSorting: true,
            enableColumnMenus: false,
            enableColumnResizing: true,
            columnDefs: [
                { name: 'Name', field: 'name', width: '33%', minWidth: '100' },
                { name: 'Library', field: 'library', width: '33%', minWidth: '100' }],
            onRegisterApi: onRegisterApi
        }

        activate();

        function activate() { }
    }
})();
